import { render } from "./TabOrders.vue?vue&type=template&id=1009c87c&scoped=true"
import script from "./TabOrders.vue?vue&type=script&lang=js"
export * from "./TabOrders.vue?vue&type=script&lang=js"

import "./TabOrders.vue?vue&type=style&index=0&id=1009c87c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1009c87c"]])

export default __exports__